// List of allowed domains (centralized)
const NOT_ALLOWED_DOMAINS_FOR_TIKTOK = [
  'matwprojectme.org',
  'matwproject.org',
  'matwproject.org.uk',
  'matwprojectusa.org',
];

export function checkDomain(...domains) {
  const domain = window.location.hostname;
  return domains.includes(domain);
}

export function shouldTrackTikTokEvent() {
  return !NOT_ALLOWED_DOMAINS_FOR_TIKTOK.includes(window.location.hostname);
}
